import * as actionTypes from "../actions/actionTypes";

const initialState = {
  hasBack: false,
  title: null,
  backButton: "<b>back</b>",
  showNotification: true,
  unreadNotifications: 0,
  backTo: null,
  isBreadCrumbs: null,
  className: null,
  backButtonData: {
    show: false,
    currentPageType: "",
  },
};

export default function (state = initialState, action) {
  // console.log(action.value)
  switch (action.type) {
    case actionTypes.NAVBAR_UPDATE:
      return { ...state, ...action.value };
    case actionTypes.NAVBAR_RESET:
      return {
        ...initialState,
        unreadNotifications: state.unreadNotifications,
      };
    default:
      break;
  }
  return state;
}
